<template>
  <div class="container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'layoutContainer'
}
</script>

<style lang="scss" scoped>
  .container {
    flex: 1;
    position: relative;
    width: 100%;
    // min-height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/container/index.vue